import APIAuth from '@/xhr/xhr-auth'
import APIUser from '@/xhr/xhr-user'
import Cookie from '../../../scripts/js.cookie.min'
import setting from '@/setting.js'

const namespaced = true

const initialState = {
  accessToken: Cookie.get('ACCESS_TOKEN'),
  userInfo: null,
  isRegisteredBirthday: false
}

export const state = {...initialState}

const getters = {
  accessToken: state => state.accessToken,
  userInfo: state => state.userInfo,
  isRegisteredBirthday: state => state.isRegisteredBirthday
}

const mutations = {
  setAccessToken (state, payload) {
    state.accessToken = payload.data.token
    Cookie.set('ACCESS_TOKEN', payload.data.token, {
      domain: setting.cookieDomain,
      secure: true, // ← https通信のみ
      httpOnly: false, // ← JavaScriptのアクセスを拒否する
      expires: 14
    })
  },
  clearData () {
    state.accessToken = null
    state.userInfo = null
    Cookie.remove('ACCESS_TOKEN')
  },
  setUserInfo (state, payload) {
    state.userInfo = payload
  },
  setIsRegisteredBirthday (state, payload) {
    state.isRegisteredBirthday = payload
  }
}

const actions = {
  // ログイン
  login ({state, commit}, param) {
    return new Promise((resolve, reject) => {
      APIAuth.login(param).then((_res) => {
        commit('setAccessToken', _res)
        resolve(_res)
      }).catch((err) => {
        commit('clearData')
        reject(err.response)
      })
    })
  },

  // 会員詳細
  getUser ({commit}) {
    return new Promise((resolve, reject) => {
      APIUser.getUser().then((_res) => {
        commit('setUserInfo', _res.data)
        commit('setIsRegisteredBirthday', !!(_res.data.birthday))
        resolve(_res.data)
      }).catch(function (err) {
        reject(err.response)
      })
    })
  },

  // パスワード変更
  changePassword ({state, commit}, param) {
    return new Promise((resolve, reject) => {
      APIUser.changePassword(param).then((_res) => {
        resolve(_res.data)
      }).catch((err) => {
        reject(err.response)
      })
    })
  },

  // 退会
  withdrawal ({commit}) {
    return new Promise((resolve, reject) => {
      APIUser.withdrawal().then((_res) => {
        commit('clearData')
        resolve(_res.data)
      }).catch((err) => {
        reject(err.response)
      })
    })
  },

  // ログアウト
  logout ({commit}) {
    return new Promise((resolve, reject) => {
      APIAuth.logout().then((_res) => {
        commit('clearData')
        resolve(_res)
      }).catch((err) => {
        reject(err.response)
      })
    })
  }
}

// モジュールに登録されるオブジェクト
export default {
  namespaced,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js